import request from "../../untils/request";

export function selectList(data) {

	return request({
		url: '/basicUser/selectList',
		method: 'get',
		params: data
	})
}

export function detail(param) {

	return request({
		url: '/basicUser',
		method: 'get',
		params: param
	})
}

export function add(data) {

	return request({
		url: '/basicUser',
		method: 'post',
		data: data
	})
}

export function remove(param) {

	return request({
		url: '/basicUser/' + param,
		method: 'delete',
	})
}

export function login(data) {

	return request({
		url: '/basicUser/login',
		method: 'post',
		data: data
	})


}

export function getUserPermission() {

	return request({
		url: '/basicUser/getUserPermission',
		method: 'get',
	})


}

export function exit() {

	return request({
		url: '/basicUser/logOut',
		method: 'get',
	})


}

export function updatePassword(data) {

	return request({
		url: '/basicUser/updatePassword',
		method: 'post',
		data: data
	})


}

export function getUserGardens(param) {

	return request({
		url: '/basicUser/getUserGardens',
		method: 'get',
		params: param
	})
}

export function getCode() {
	return request({
		url: '/basicUser/getVerifyCode',
		method: 'get',
	})
}
export function setAdmin(param) {
	return request({
		url: '/basicUser/setAdmin',
		method: 'get',
		params: param
	})
}
export function cancelAdmin(param) {
	return request({
		url: '/basicUser/cancelAdmin',
		method: 'get',
		params: param
	})
}